import { ColorEnum } from '@/constants/color'
import type { CatalogProduct } from '@/features/openTabs/components/ProductCatalog'
import ProductContent from '@/features/pos/components/ProductCatalog/parts/ProductList/parts/Product/parts/Content'
import { FC } from 'react'
import { createStyleSheet } from 'react-native-unistyles'

interface ProductCardProps {
    product: CatalogProduct
    selected: boolean
    disabled?: boolean
    onPress: () => void
}

const ProductCard: FC<ProductCardProps> = ({ product, selected, disabled = false, onPress }) => {
    return (
        <ProductContent
            name={product.name}
            price={product.price}
            soldOut={product.soldOut}
            variantQuantity={product.variantQuantity}
            labelName={product.label?.name}
            labelColor={product.label?.color}
            selected={selected}
            disabled={disabled}
            onPress={onPress}
            style={[
                styles.container,
                selected && styles.selectedContainer,
                disabled && styles.disabledContainer,
            ]}
        />
    )
}

const styles = createStyleSheet({
    container: {
        flex: 1,
    },
    selectedContainer: {
        borderColor: ColorEnum.Blue600,
        backgroundColor: ColorEnum.Blue100,
    },
    disabledContainer: {
        opacity: 0.5,
    },
})

export default ProductCard
